/**
 * Created by Ram on 17/03/2017.
 */

import React, { Component } from 'react';
import TestInstanceList from './TestInstanceManagement/TestInstanceList';
import TestInstanceOverview from './TestInstanceManagement/TestInstanceOverview';
import TestInstanceDevicesList from './TestInstanceManagement/TestInstanceDevicesList';
import { getEnvironmentShort, getErrorMessage } from '../../util/helpers';

class TestInstanceManagement extends Component {
    checkTestState = testInstance => {
        let { startTime, endTime } = testInstance;
        const currentTime = new Date();

        startTime = startTime ? new Date(startTime) : null;
        endTime = endTime ? new Date(endTime) : null;

        let deviceStates = Object.values(testInstance.devices);

        const ready = deviceStates.every(({ batteryReady, hostReady }) => batteryReady || hostReady);

        if (deviceStates.some(({ error }) => error)) {
            return 'Error';
        }

        if (!startTime || currentTime < startTime) {
            return 'Planned';
        }

        if (!endTime || currentTime < endTime) {
            return ready ? 'In Progress' : 'Initialising';
        }

        return ready ? 'Completed' : 'Finished';
    };

    overviewList = () => {
        let overviewList = {};
        const { testInstance, scenarioName, scenarioEnvironment, scenarioDeviceDPH, startTimeDisplay, durationDisplay } = this.props.loadData;

        if (testInstance === '') {
            overviewList.status = ''
        } else if(this.checkTestState(testInstance) === ''){
            overviewList.status = 'Not specified';
        } else {
            overviewList.status = this.checkTestState(testInstance);
        }

        if (scenarioName === '') {
            overviewList.scenario = 'Not specified';
        } else {
            overviewList.scenario = scenarioName;
        }

        if (testInstance.sdkVersion === '') {
            overviewList["sdk Version"] = 'Not specified';
        } else {
            overviewList["sdk Version"] = testInstance.sdkVersion
        }

        overviewList.environment = getEnvironmentShort(scenarioEnvironment);

        if (testInstance.mode === '') {
            overviewList.mode = 'Not specified';
        } else {
            overviewList.mode = testInstance.mode;
        }

        overviewList["Start Time"] = startTimeDisplay;
        overviewList["Time Elapsed"] = durationDisplay;
        overviewList["iOS BG Loc Indicator"] = testInstance.enableBackgroundLocationIndicator?"true":"false";
        overviewList["Android BG Mode"] = testInstance.enableBGMode?"true":"false"

        overviewList["Device DPH"] = scenarioDeviceDPH != null && !isNaN(scenarioDeviceDPH) ? scenarioDeviceDPH + "%" : "N/A";

        return overviewList;
    };

    generateArrow = condition => (
        <span className={`glyphicon glyphicon-triangle-${condition ? `bottom` : `top`}`} title="Active" />
    );

    render() {
        const {
            refreshDeviceList,
            deleteTestInstance,
            navigator,
            updateSortState,
            updateDevicesSortState,
            startStopInstance,
            updateSearchState,
            getSingleTestInstance,
            showEditTestInstance,
            cloneTestInstance,
            updateComments
        } = this.props;

        let {
            testInstances,
            testInstance,
            devices,
            sort,
            sortAsc,
            sortDevices,
            sortDevicesAsc,
            isLoading,
            startStopTest,
            displayButton,
            comments,
            search
        } = this.props.loadData;

        const arrow = this.generateArrow(sortAsc);
        const arrowDevices = this.generateArrow(sortDevicesAsc);

        let deviceListDisplay;

        if (devices.length) {
            deviceListDisplay = devices.map(device => {
                let status = ''
                let currentTestInstanceDevice = null

                for (let instanceDevice of testInstance.devices) {
                    if (instanceDevice.deviceId === device._id) {
                        currentTestInstanceDevice = instanceDevice;
                        break;
                    }
                }

                if (currentTestInstanceDevice) {
                    if (currentTestInstanceDevice['error']) {
                        status = getErrorMessage(currentTestInstanceDevice, testInstance.sdkVersion, device.osVersion)
                    } else {
                        if (typeof currentTestInstanceDevice['batteryReady'] !== 'undefined') {
                            if (currentTestInstanceDevice['batteryReady']) {
                                status = 'Battery started ';
                            } else {
                                status = 'Battery pending ';
                            }
                        }

                        if (typeof currentTestInstanceDevice['hostReady'] !== 'undefined') {
                            if (currentTestInstanceDevice['hostReady']) {
                                status = status + 'Host started';
                            } else {
                                status = status + 'Host pending';
                            }
                        }
                    }
                }

                return (
                    <tr key={device._id} className={device.trackingDevice && 'tracking-device-color'}>
                        <td>{device.name}</td>
                        <td>{device.model}</td>
                        <td>{device.os}</td>
                        <td>{device.osVersion}</td>
                        <td>{device.deviceType}</td>
                        <td>{status}</td>
                    </tr>
                );
            });
        }

        return (
            <div>
                <ol className="breadcrumb">
                    <li className="active">Test Instance Management</li>
                </ol>

                <div className="test-instances-main-div pull-left">
                    <div className="search-test-instance">
                        <div className="row">
                            <div className="col-sm-4">
                                <span className="block-heading">
                                    <span className="glyphicon glyphicon-asterisk" /> Test Instances
                                </span>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    type="button"
                                    className="btn btn-add pull-right"
                                    onClick={navigator.requestAddNewTestInstance}
                                >
                                    <span className="glyphicon glyphicon-plus" />
                                    New
                                </button>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="search"
                                    placeholder="Search..."
                                    className="form-control test-instance-search"
                                    onChange={updateSearchState}
                                    value={search}
                                />
                            </div>
                        </div>
                    </div>

                    <TestInstanceList
                        testInstances={testInstances}
                        selectedInstanceId={testInstance._id}
                        deleteTestInstance={deleteTestInstance}
                        updateSortState={updateSortState}
                        sort={sort}
                        arrow={arrow}
                        isLoading={isLoading}
                        checkTestState={this.checkTestState}
                        getSingleTestInstance={getSingleTestInstance}
                        showEditTestInstance={showEditTestInstance}
                        cloneTestInstance={cloneTestInstance}
                    />
                </div>

                <TestInstanceOverview
                    name={testInstance.name}
                    comments={comments}
                    overviewList={this.overviewList()}
                    updateComments={updateComments}
                    id={testInstance._id}
                    deviceListDisplay={deviceListDisplay}
                    startStopInstance={startStopInstance}
                    startStopTest={startStopTest}
                    displayButton={displayButton}
                    refreshDeviceList={refreshDeviceList}
                />

                <TestInstanceDevicesList
                    updateSort={updateDevicesSortState}
                    sort={sortDevices}
                    arrow={arrowDevices}
                    devices={deviceListDisplay}
                />
            </div>
        ); // return
    } // render
} // TestInstanceManagement

export default TestInstanceManagement;
